import React, { useRef, useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchDropDownData,
  fetchSubjectData,
} from '../../../actions/raceAndExerciseActions';
import './styles.scss';
import Grid from '@material-ui/core/Grid';
import PopUpModal from '../../../components/PopUpModal';
import List from '@material-ui/core/List';
import NoData from '../../../components/NoData';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ListSubheader from '@material-ui/core/ListSubheader';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Card from '@material-ui/core/Card';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PageHeading from '../../../components/PageHeading';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import QuestionSolution from './QuestionSolution';
import { Skeleton } from '@material-ui/lab';

import ScrollToTop from '../../../components/ScrollToTop';

const useStyles = makeStyles((theme) => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%',
    },
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));

export default function RaceNExcercise() {
  //style
  const classes = useStyles();
  const childRef = useRef();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  //State
  const [subject, setSubject] = useState('');
  const [secondDropdown, setSecondDropdown] = useState(false);
  const [index, setIndex] = useState(-1);
  const [subIndex, setSubIndex] = useState(-1);
  const [workBookID, setworkBookID] = useState(0);
  const [selectedWorkbook, setselectedWorkbook] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedTopic, setselectedTopic] = useState('');
  const [selectedExercise, setselectedExercise] = useState('');
  const [visible, setVisible] = React.useState({
    workbook: true,
    subject: false,
    topic: false,
    exercise: false,
  });
  const [isFetchingDropDownData, setIsFetchingDropDownData] = useState(false);
  const [isFetchingSubjectData, setIsFetchingSubjectData] = useState(false);

  //Redux
  const dispatch = useDispatch();

  //functions
  useEffect(() => {
    setIsFetchingDropDownData(true);
    fetchDropDownData(jwtToken, dispatch).then(() => {
      setIsFetchingDropDownData(false);
    });
  }, []);

  useEffect(() => {
    if (subject) {
      setIsFetchingSubjectData(true);
      fetchSubjectData(subject, jwtToken, dispatch).then(() => {
        setIsFetchingSubjectData(false);
      });
    }
  }, [subject]);

  //variables

  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );
  const dropdownData = useSelector((state) =>
    get(state, 'raceAndExerciseReducer.data', [])
  );
  const subjectData = useSelector((state) =>
    get(state, 'raceAndExerciseReducer.subjectData', [])
  );
  const errorMessage = useSelector((state) =>
    get(state, 'raceAndExerciseReducer.errorMessage', '')
  );

  const populateWorkbookData = () => {
    let whenLoading = [1, 1, 1, 1,1,1,1,1];
    const list = [];
    (isFetchingDropDownData ? whenLoading : dropdownData).map((data, index) => {
      if (isFetchingDropDownData) {
        list.push(
          <ListItem key={index}>
            <Skeleton width="60%"/>
          </ListItem>
        );
      } else {
        list.push(
          <ListItem
            button
            key={index}
            value={data.WorkBookTypeID}
            onClick={(e) => {
              handleChangeWorkbook(e, data.WorkBookTypeID);
              setselectedWorkbook(data.WorkBookTypeTitle);
            }}
          >
            <ListItemText
              className={
                selectedWorkbook === data.WorkBookTypeTitle ? 'active' : ''
              }
              primary={data.WorkBookTypeTitle}
            />
            <ListItemIcon>
              <KeyboardArrowRightIcon />
            </ListItemIcon>
          </ListItem>
        );
      }
    });
    return list;
  };

  const populateSubjectData = () => {
    let whenLoading = [1, 1, 1, 1];
    const list = [];
    (isFetchingSubjectData ? whenLoading : subjectData).map((data, index) => {
      if (isFetchingSubjectData) {
        list.push(
          <ListItem key={index}>
            <Skeleton width={'75%'} />
          </ListItem>
        );
      } else {
        list.push(
          <ListItem
            button
            key={index}
            value={index}
            onClick={(e) => {
              handleSubjData(e, index);
              setselectedTopic('');
              setselectedExercise('');
              setSelectedSubject(data.SubjectTitle);
            }}
          >
            <ListItemText
              className={selectedSubject === data.SubjectTitle ? 'active' : ''}
              primary={data.SubjectTitle}
            />
            <ListItemIcon>
              <KeyboardArrowRightIcon />
            </ListItemIcon>
          </ListItem>
        );
      }
    });
    return list;
  };

  const populateRaceExercise = () => {
    const list = [];

    if (index > -1)
      subjectData[index].workBook.map((data, index) => {
        list.push(
          <ListItem
            button
            key={index}
            value={index}
            onClick={() => {
              setSubIndex(index);
              setselectedTopic(!isEmpty(data.SyllabusTitle) ? data.SyllabusTitle : `Topic-${index + 1}`);
              setVisible({
                workbook: false,
                subject: false,
                topic: false,
                exercise: true,
              });
            }}
          >
            <ListItemText
              className={(selectedTopic === data.SyllabusTitle || selectedTopic === `Topic-${index + 1}`) ? 'active' : ''}
              primary={!isEmpty(data.SyllabusTitle) ? data.SyllabusTitle : `Topic-${index + 1}`}
            />
            <ListItemIcon>
              <KeyboardArrowRightIcon />
            </ListItemIcon>
          </ListItem>
        );
      });
    return list;
  };

  const header = <div>Exercise & RACE</div>;

  const populateExercise = () => {
    const list = [];
    if (subIndex > -1)
      subjectData[index].workBook[subIndex].workBookList.map((data, index) => {
        list.push(
          !isEmpty(data.WorkBookURL) ? 
          <a
          href={data.WorkBookURL}
          target="_blank"
          rel="noopener noreferrer"
          download
          key={index}
        >
          <ListItem
            button
            key={index}
            value={index}
            onClick={() => {
              setselectedExercise(
                `${data.WorkBookSyllabi} - ${data.WorkBooName}`
              );
              setworkBookID(data.WorkBookID);
            }}
          >
            <ListItemText
              className={
                selectedExercise ===
                `${data.WorkBookSyllabi} - ${data.WorkBooName}`
                  ? 'active'
                  : ''
              }
              primary={`${data.WorkBookTypeTitle} - ${data.WorkBooName} ${
                data.TotalQuestion ? `(${data.TotalQuestion})` : ''
              }`}
            />
            <ListItemIcon>
              <KeyboardArrowRightIcon />
            </ListItemIcon>
          </ListItem>
          </a> :
          <ListItem
          button
          key={index}
          value={index}
          onClick={() => {
            setselectedExercise(
              `${data.WorkBookSyllabi} - ${data.WorkBooName}`
            );
            childRef.current.handleClickOpen();
            setworkBookID(data.WorkBookID);
          }}
        >
          <ListItemText
            className={
              selectedExercise ===
              `${data.WorkBookSyllabi} - ${data.WorkBooName}`
                ? 'active'
                : ''
            }
            primary={`${data.WorkBookTypeTitle} - ${data.WorkBooName} ${
              data.TotalQuestion ? `(${data.TotalQuestion})` : ''
            }`}
          />
          <ListItemIcon>
            <KeyboardArrowRightIcon />
          </ListItemIcon>
        </ListItem>
        );
      });
    return list;
  };

  const selectedItems = {
    workBook: selectedWorkbook,
    subject: selectedSubject,
    topic: selectedTopic,
    exercise: selectedExercise,
  };
  const body = (
    <QuestionSolution workBook={workBookID} selectedItems={selectedItems} />
  );

  const handleChangeWorkbook = (event, item) => {
    setSubject(item);
    setselectedExercise('');
    setselectedTopic('');
    setSelectedSubject('');
    setSecondDropdown(true);
    setVisible({
      workbook: false,
      subject: true,
      topic: false,
      exercise: false,
    });
  };

  const handleSubjData = (event, index) => {
    setIndex(index);
    setVisible({
      workbook: false,
      subject: false,
      topic: true,
      exercise: false,
    });
  };

  const handleBackButton = () => {
    if (visible.subject === true) {
      setVisible({
        workbook: true,
        subject: false,
        topic: false,
        exercise: false,
      });
    } else if (visible.topic === true) {
      setVisible({
        workbook: false,
        subject: true,
        topic: false,
        exercise: false,
      });
    } else {
      setVisible({
        workbook: false,
        subject: false,
        topic: true,
        exercise: false,
      });
    }
  };
  // For Scroll only in desktop
  const MyScrollBar = matches === true ? PerfectScrollbar : 'div';
  return (
    <React.Fragment>
      <PageHeading titlePrimary="Exercise &" titleSecondary="RACE" />
      {(!isEmpty(dropdownData) || (isFetchingDropDownData || isFetchingSubjectData))? (
        <>
          <Card className="card body-select-dailogs">
            {matches === false && visible.workbook === false && (
              <div onClick={handleBackButton} className="back-btn">
                <ArrowBackIcon /> Back
              </div>
            )}
            <Grid container className="multiple-list">
              <Grid item xs>
                <div className="list-card-subjects border-none">
                  {(!(matches === false && visible.workbook === false) || isFetchingDropDownData) && (
                    <MyScrollBar>
                      <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                          <ListSubheader
                            component="div"
                            id="nested-list-subheader"
                          >
                            Select a Workbook Type
                          </ListSubheader>
                        }
                      >
                        <ScrollToTop />
                        {(!(matches === false && visible.workbook === false) &&
                          !isEmpty(dropdownData) || isFetchingDropDownData) &&
                          populateWorkbookData()}
                      </List>
                    </MyScrollBar>
                  )}
                </div>
              </Grid>
              {(!(matches === false && visible.subject === false) || isFetchingSubjectData) &&
                secondDropdown &&
                selectedWorkbook && (
                  <Grid item xs>
                    <div className="list-card-subjects">
                      <MyScrollBar>
                        <List
                          component="nav"
                          aria-labelledby="nested-list-subheader"
                          subheader={
                            <ListSubheader
                              component="div"
                              id="nested-list-subheader"
                            >
                              Select a Subject
                            </ListSubheader>
                          }
                        >
                          <ScrollToTop />
                          {populateSubjectData()}
                        </List>
                      </MyScrollBar>
                    </div>
                  </Grid>
                )}

              {!(matches === false && visible.topic === false) &&
                index > -1 &&
                selectedSubject && (
                  <Grid item xs>
                    <div className="list-card-subjects">
                      <MyScrollBar>
                        <List
                          component="nav"
                          aria-labelledby="nested-list-subheader"
                          subheader={
                            <ListSubheader
                              component="div"
                              id="nested-list-subheader"
                            >
                              Select a Topic
                            </ListSubheader>
                          }
                        >
                          <ScrollToTop />
                          {populateRaceExercise()}
                        </List>
                      </MyScrollBar>
                    </div>
                  </Grid>
                )}
              {!(matches === false && visible.exercise === false) &&
                index > -1 &&
                subIndex > -1 &&
                selectedTopic && (
                  <Grid item xs>
                    <div className="list-card-subjects">
                      <MyScrollBar>
                        <List
                          component="nav"
                          aria-labelledby="nested-list-subheader"
                          subheader={
                            <ListSubheader
                              component="div"
                              id="nested-list-subheader"
                            >
                              Select an Exercise
                            </ListSubheader>
                          }
                        >
                          <ScrollToTop />
                          {populateExercise()}
                        </List>
                      </MyScrollBar>
                    </div>
                  </Grid>
                )}
            </Grid>
          </Card>
          <PopUpModal
            ref={childRef}
            header={header}
            body={body}
            width={classes.dialogCustomizedWidth}
            position={classes.dialogPosition}
            fullScreen={true}
            className="question-popup"
          />
        </>
      ) : (
        <NoData
          message={
            !isEmpty(errorMessage)
              ? errorMessage
              : 'As of now, No Race and Exercise available for you. Please come back later.'
          }
        />
      )}
    </React.Fragment>
  );
}
